import { } from 'react'
import { Link } from 'react-router-dom'
import { Heart, Shield, Users, Zap } from 'lucide-react'

export function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-2">
            <div className="text-2xl font-bold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent mb-3 md:mb-4">
              Next Level BR
            </div>
            <p className="text-gray-400 text-sm md:text-base mb-4 md:mb-6 max-w-md">
              A plataforma premium que conecta modelos e clientes através de um sistema inovador de chat público com monetização por tokens.
            </p>
            <div className="grid grid-cols-3 gap-3 md:flex md:space-x-4">
              <div className="flex items-center space-x-2 text-[11px] md:text-sm text-gray-400">
                <Shield className="w-4 h-4 text-green-400" />
                <span>100% Seguro</span>
              </div>
              <div className="flex items-center space-x-2 text-[11px] md:text-sm text-gray-400">
                <Users className="w-4 h-4 text-blue-400" />
                <span>Chat em Tempo Real</span>
              </div>
              <div className="flex items-center space-x-2 text-[11px] md:text-sm text-gray-400">
                <Zap className="w-4 h-4 text-yellow-400" />
                <span>Sistema de Tokens</span>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-3 md:mb-4">Plataforma</h3>
            <ul className="space-y-1 md:space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/models" className="text-gray-400 hover:text-white transition-colors">
                  Modelos
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-400 hover:text-white transition-colors">
                  Cadastrar-se
                </Link>
              </li>
              <li>
                <Link to="/tokens" className="text-gray-400 hover:text-white transition-colors">
                  Comprar Tokens
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-3 md:mb-4">Suporte</h3>
            <ul className="space-y-1 md:space-y-2 text-sm">
              <li>
                <Link to="/help" className="text-gray-400 hover:text-white transition-colors">
                  Central de Ajuda
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contato
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 md:mt-8 pt-5 md:pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-xs md:text-sm">
            © 2024 Next Level BR. Todos os direitos reservados.
          </div>
          <div className="flex items-center space-x-1 text-gray-400 text-xs md:text-sm mt-3 md:mt-0">
            <span>Feito com</span>
            <Heart className="w-4 h-4 text-red-500" />
            <span>por elas</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
